import React from 'react';
import Button from '../ui/Button';

interface CtaSectionProps {
  title: string;
  subtitle?: string;
  buttonText: string;
  buttonLink: string;
}

const CtaSection: React.FC<CtaSectionProps> = ({ 
  title, 
  subtitle, 
  buttonText, 
  buttonLink 
}) => {
  return (
    <section className="bg-primary py-16 md:py-24">
      <div className="container-custom text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">{title}</h2>
        {subtitle && (
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">{subtitle}</p>
        )}
        <Button to={buttonLink} variant="outline" className="border-white text-white hover:bg-white hover:text-primary">
          {buttonText}
        </Button>
      </div>
    </section>
  );
};

export default CtaSection;